import { warn } from '@helsenorge/framework-utils/logger';
import { getCookieConsentOptions } from './cookie';
var AdobeOptin;
(function (AdobeOptin) {
    AdobeOptin["AdobeAnalytics"] = "aa";
    AdobeOptin["ExperienceCloudID"] = "ecid";
})(AdobeOptin || (AdobeOptin = {}));
/**
 * Oppdater Adobe Opt-in Service med brukerens cookie-samtykker.
 *
 * Dersom bruker har samtykket til analyse-cookies, kan Adobe Analytics spore brukerens aktivitet.
 *
 * @param options Brukerens cookie-samtykker
 */
export const setAdobeAnalyticsConsent = (options) => {
    let attempts = 0;
    const MAX_ATTEMPTS = 10;
    const RETRY_DELAY_MS = 1000;
    const waitForAdobe = () => {
        if (window.adobe?.optIn) {
            if (options.AnalyticsCookies) {
                window.adobe.optIn.approve([AdobeOptin.AdobeAnalytics, AdobeOptin.ExperienceCloudID]);
            }
            else {
                window.adobe.optIn.deny([AdobeOptin.AdobeAnalytics, AdobeOptin.ExperienceCloudID]);
            }
        }
        else if (attempts < MAX_ATTEMPTS) {
            attempts++;
            setTimeout(waitForAdobe, RETRY_DELAY_MS);
        }
        else {
            warn(`adobe.optIn er ikke tilgjengelig etter ${attempts} forsøk med ${RETRY_DELAY_MS}ms mellomrom.`);
        }
    };
    waitForAdobe();
};
/**
 * Oppdater Adobe Opt-in Service med brukerens cookie-samtykker.
 */
export const updateAdobeAnalyticsConsent = () => {
    const options = getCookieConsentOptions();
    setAdobeAnalyticsConsent(options);
};
